import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../../services/api";
import { indexar } from "../../domain/compra/pedido";

// El mapa publicado del evento para comprar. Si el evento no tiene mapa del
// editor nuevo queda en null y la compra sigue con el selector de siempre.
export const MapaCompraContext = createContext({ mapa: null, indice: null, cargado: true, recargar: async () => null });

export const useMapaCompra = () => useContext(MapaCompraContext);

export const useMapaPublico = (eventoId) => {
  const [mapa, setMapa] = useState(null);
  // hasta la primera respuesta no se sabe si hay mapa: la lista de entradas espera
  const [cargado, setCargado] = useState(false);

  const recargar = useCallback(async () => {
    if (!eventoId) return null;
    try {
      const respuesta = await api.mapa.publico(eventoId);
      const nuevo = respuesta.status === "success" ? respuesta.data : null;
      setMapa(nuevo);
      return nuevo;
    } catch {
      return null;
    } finally {
      setCargado(true);
    }
  }, [eventoId]);

  useEffect(() => {
    recargar();
  }, [recargar]);

  const indice = useMemo(() => (mapa ? indexar(mapa) : null), [mapa]);
  return useMemo(() => ({ mapa, indice, cargado, recargar }), [mapa, indice, cargado, recargar]);
};
